/**
 * Format MAC address.
 *
 * @param macAddress The MAC address.
 *
 * @returns The formatted MAC address.
 */
export function formatMacAddress(macAddress: string): string {
  const matches = macAddress.match(/.{1,2}/g)

  return matches !== null ? matches.join(':').toUpperCase() : macAddress
}

/**
 * Formats the temperature in one decimal precision.
 */
export function formatTemperature(value: number, unit = true): string {
  const roundedValue = Math.round(value * 10) / 10

  return unit ? `${roundedValue.toFixed(1)}°C` : roundedValue.toFixed(1)
}

/**
 * Formats the temperature as delta value.
 */
export function formatTemperatureDelta(value: number, unit = true): string {
  const roundedValue = Math.round(value * 10) / 10

  const sign = roundedValue > 0 ? '+' : ''
  const formattedValue = unit ? `${roundedValue.toFixed(1)}°C` : roundedValue.toFixed(1)

  return `${sign}${formattedValue}`
}

/**
 * Formats the humidity in integer precision.
 */
export function formatHumidity(value: number, unit = true): string {
  const roundedValue = Math.round(value)

  return unit ? `${roundedValue}%` : `${roundedValue}`
}

/**
 * Formats the humidity as delta value.
 */
export function formatHumidityDelta(value: number, unit = true): string {
  const roundedValue = Math.round(value * 10) / 10

  const sign = roundedValue > 0 ? '+' : ''
  const formattedValue = unit ? `${roundedValue.toFixed(1)}%` : roundedValue.toFixed(1)

  return `${sign}${formattedValue}`
}

/**
 * Formats the pressure in integer precision.
 */
export function formatPressure(value: number, unit = true): string {
  const roundedValue = Math.round(value * 10) / 10

  return unit ? `${roundedValue.toFixed(1)} HPa` : roundedValue.toFixed(1)
}

/**
 * Formats the pressure as delta value.
 */
export function formatPressureDelta(value: number, unit = true): string {
  const roundedValue = Math.round(value * 10) / 10

  const sign = roundedValue > 0 ? '+' : ''
  const formattedValue = unit ? `${roundedValue.toFixed(1)} HPa` : `${roundedValue.toFixed(1)}`

  return `${sign}${formattedValue}`
}

export function formatPercentage(value: number, unit = true): string {
  const roundedValue = Math.round(value)

  return unit ? `${roundedValue}%` : `${roundedValue}`
}

export function formatPercentageDelta(value: number, unit = true): string {
  const roundedValue = Math.round(value * 10) / 10

  const sign = roundedValue > 0 ? '+' : ''
  const formattedValue = unit ? `${roundedValue.toFixed(1)}%` : roundedValue.toFixed(1)

  return `${sign}${formattedValue}`
}

export function formatDegress(value: number, unit = true): string {
  const roundedValue = Math.round(value * 10) / 10

  return unit ? `${roundedValue.toFixed(1)}°` : roundedValue.toFixed(1)
}
